import {auth} from '@/api-services'
import {paginationHandler, parseLinkHeader} from '@/utils/common'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'

export const useUserStore = defineStore('userStore', {
  state: () => ({
    allUsers: [],
    allAdmins: [],
    allUnconfirmedUsers: [],
    userDetail: {},
    loading: false,
    actionLoading: false,
    isUserCreateSuccess: false,
    error: null,
    links: {},
    users: [],
    admins: [],
    unConfirmedUsers: [],
    usersLink: {},
    adminsLink: {},
    unConfirmedUsersLink: {},
    usersLoading: false,
    adminsLoading: false,
    unConfirmedUsersLoading: false,
    currentPage: {
      users: 1,
      admins: 1,
      unConfirmedUsers: 1,
    },
    perPage: 20,
  }),
  getters: {
    getAllUsersWithSerialNumber(state) {
      return state.users.map((val, index) => ({
        ...val,
        serialNumber: (state.currentPage.users - 1) * state.perPage + index + 1,
      }))
    },

    getUnConfirmedUsersWithSerialNumber(state) {
      return state.unConfirmedUsers.map((val, index) => ({
        ...val,
        serialNumber: (state.currentPage.unConfirmedUsers - 1) * state.perPage + index + 1,
      }))
    },

    getAllAdminsWithSerialNumber(state) {
      return state.admins.map((val, index) => ({
        ...val,
        serialNumber: (state.currentPage.admins - 1) * state.perPage + index + 1,
      }))
    },
  },
  actions: {
    async getAllUser() {
      this.loading = true
      try {
        const response = await auth.getAllUser()
        const data = await response.data
        this.allUsers = data
        this.users = data
        this.usersLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getAllAdmin() {
      this.loading = true
      try {
        const response = await auth.getAllAdmin()
        const data = await response.data
        this.admins = data
        this.allAdmins = data
        this.adminsLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getAllUnconfirmedUser() {
      this.loading = true
      try {
        const response = await auth.getUnconfirmedUsers()
        const data = await response.data
        this.unConfirmedUsers = data
        this.allUnconfirmedUsers = data
        this.unConfirmedUsersLink = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getUserById(id) {
      this.loading = true
      try {
        const response = await auth.getUser(id)
        const data = await response.data
        this.userDetail = data[0]
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async createUser(payload) {
      this.loading = true
      try {
        const response = await auth.userSignUp(payload)
        const data = await response.data
        this.userDetail = data[0]
        this.isUserCreateSuccess = true
        toast.success(successHandler('CREATE_USER_SUCCESS'))
        toast.success(successHandler('CONFIRMATION_EMAIL_SENT'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getTablePagination(page, type=null) {
      if (type) {
        this[`${type}Loading`] = true
      } else {
        this.loading = true
      }
      let response = []
      try {
        if (page === 'next') {
          this.currentPage[type] += 1
          response = await paginationHandler(this[`${type}Link`].next)
        } else if (page === 'prev') {
          this.currentPage[type] -= 1
          response = await paginationHandler(this[`${type}Link`].prev)
        }
        this[type] = response.data
        if (type) {
          this[`${type}Link`] = parseLinkHeader(response.headers.link)
        } else {
          this.link = parseLinkHeader(response.headers.link)
        }
      } catch (error) {
        const errorMsg = errorHandler(error)
        this.error = errorMsg
        toast.error(errorMsg)
      } finally {
        if (type) {
          this[`${type}Loading`] = false
        } else {
          this.loading = false
        }
      }
    },
  },
})
